module.exports = __webpack_public_path__ + "static/media/downline-icon-white.e269b836.svg";